import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  ChapterinnerGET,
  ChapterinnerPageGET,
  ChapterPagePUT,
} from "../../../services/Chapter";
import {
  Box,
  IconButton,
  Typography,
  Grid,
  Snackbar,
  Alert,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { SearchWithAction } from "../../../components/resuable/PageHeader";
import { ChapterCard } from "../../../components/resuable/ChapterCard";

export default function Chapterpages() {
  const { slug } = useParams();
  const [chapter, setChapter] = useState(null);
  const navigate = useNavigate();
  const [card, setCard] = useState([]);
  const [editId, setEditId] = useState(null); // <-- to track edit
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const location = window.location.pathname.split("/");
  console.log(error);
  // Snackbar
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  console.log(card, "card???");
  const FetchGETChapterPage = async () => {
    const res = await ChapterinnerGET(
      location.includes("user") ? `users/chapters/${slug}` : `chapters/${slug}`
    );

    if (res.status) {
      setChapter(res.data);
    } else {
      setError(res.message);
      setChapter(null);
    }
  };

  useEffect(() => {
    FetchGETChapterPage();
  }, [slug]);

  const FetchGETPages = async () => {
    const payload = location.includes("user")
      ? `users/chapters/${slug}/pages`
      : `pages/${slug}`;
    const response = await ChapterinnerPageGET(payload);
    console.log(response.data, "data");
    if (response.status) {
      setCard(response.data);
    } else {
      setError(response.message);
    }
  };
  useEffect(() => {
    FetchGETPages();
  }, []);
  // Switch Active/Inactive
  const onSwitch = async (id) => {
    const current = card.find((i) => i._id == id);
    console.log(current, "current");
    try {
      if (!current) return;

      const updatedStatus = !current.is_active;
      const res = await ChapterPagePUT(id, { is_active: updatedStatus });
      // const res = { status: true };
      console.log(res, "resNNHNHNNGNH");
      if (res.status) {
        setCard((prev) =>
          prev.map((c) =>
            c._id === id ? { ...c, is_active: res?.data?.is_active } : c
          )
        );

        setSnackbar({
          open: true,
          message: updatedStatus
            ? res.message || "Chapter activated successfully"
            : res.message || "Chapter deactivated successfully",
          severity: "success",
        });
      } else {
        setSnackbar({
          open: true,
          message: res.message || "Failed to update chapter",
          severity: "error",
        });
      }
    } catch (error) {
      console.error("Error updating chapter:", error);
      setSnackbar({
        open: true,
        message: "Something went wrong while updating chapter",
        severity: "error",
      });
    }
  };

  if (error && card.length === 0) {
    return (
      <Typography variant="captions" color="danger">
        {error}
      </Typography>
    );
  }
  return (
    <Box p={2}>
      {/* Header */}

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 3,
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <IconButton onClick={() => navigate(-1)}>
            <ChevronLeftIcon />
          </IconButton>
          <Typography variant="h6" ml={1}>
            {chapter?.chapter_name || "Chapter"}
          </Typography>
        </Box>
        <Box>
          {location.includes("user") ? null : (
            <SearchWithAction
              placeholder="Search ...."
              buttonText="Create Pages"
              onButtonClick={() => {
                navigate(`/chapter/page/${slug}/create`);
              }}
            />
          )}
        </Box>
      </Box>

      {/* No Data State */}
      <Grid container spacing={3} justifyContent={"center"}>
        {card.map((card) => (
          <Grid key={card.title} size={{ xs: 12, sm: 6, md: 4 }}>
            <ChapterCard
              onEdit={(id) => {
                navigate(`/chapter/page/${id}/edit`);
              }}
              id={card._id}
              word={card.page_name}
              label={card.page_name}
              switchValue={card.is_active}
              onSwitch={onSwitch}
              handleCardClick={() =>
                navigate(
                  location.includes("user")
                    ? `/user/chapter/page/${card.page_id}/view/`
                    : `/chapter/page/${card._id}/view/`
                )
              }
            />
          </Grid>
        ))}
      </Grid>
      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
